// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","borderGrey":"#d5dfdf","errorRed":"#ff2a2a","body":"_2lYHSCAcM6vA2s-47YYZeS","caption":"_1dJD2pSCq2-UhXWE_3mRfd","textGrey":"#3f3f3f","container":"_1JGEFbxKxk8zAkbxygsTgw","street":"_2a24QXwJTPPRVtsi9b4Acs _2lYHSCAcM6vA2s-47YYZeS","info":"_31IYruZGeVXfLCGkEObvXr _1dJD2pSCq2-UhXWE_3mRfd","buttonContainer":"BR-bklohiJn4LRS6johV0","error":"x-FeI13Oliz1qvvZhlats _1dJD2pSCq2-UhXWE_3mRfd","button":"_3_25b8cQMwIVx-JPc2xHR6"};


//////////////////
// WEBPACK FOOTER
// ./src/common/address-card/AddressCard.css
// module id = 437
// module chunks = 0 1 2